
export type TSimpleSelectOnChangeParams = {
  value: string;
};

type TSimpleSelectOption = {
  label: string;
  value: string;
};

type TSimpleSelectProps = {
  name?: string;
  onChange: (params: TSimpleSelectOnChangeParams) => void;
  value: string;
  options: TSimpleSelectOption[];
};

export function SimpleSelect(props: TSimpleSelectProps) {
  const onChange = (ev: any) => {
    if (props.onChange) {
      props.onChange({ value: ev.target.value });
    }
  };

  return (
    <div className="slds-select_container">
      <select className="slds-select" name={props.name} onChange={onChange} defaultValue={props.value}>
        {props.options.map((opt: any) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}
